var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 16V10M7.5 10L4.5 12M7.5 10L10.5 12M8.5 1.00087C8.40451 1 8.29728 1 8.17471 1H3.7002C2.58009 1 2.01962 1 1.5918 1.21799C1.21547 1.40973 0.909734 1.71547 0.717987 2.0918C0.5 2.51962 0.5 3.08009 0.5 4.2002V15.8002C0.5 16.9203 0.5 17.4801 0.717987 17.9079C0.909734 18.2842 1.21547 18.5905 1.5918 18.7822C2.01921 19 2.579 19 3.69694 19L11.3031 19C12.421 19 12.98 19 13.4074 18.7822C13.7837 18.5905 14.0905 18.2842 14.2822 17.9079C14.5 17.4805 14.5 16.9215 14.5 15.8036V7.32568C14.5 7.20296 14.5 7.09561 14.4991 7M8.5 1.00087C8.78564 1.00347 8.96634 1.01385 9.13884 1.05526C9.34291 1.10425 9.53785 1.18526 9.7168 1.29492C9.91857 1.41857 10.0918 1.59182 10.4375 1.9375L13.563 5.06298C13.9089 5.40889 14.0809 5.58136 14.2046 5.78319C14.3142 5.96214 14.3953 6.15726 14.4443 6.36133C14.4857 6.53376 14.4963 6.71451 14.4991 7M8.5 1.00087V3.8C8.5 4.9201 8.5 5.47977 8.71799 5.90759C8.90973 6.28392 9.21547 6.59048 9.5918 6.78223C10.0192 7 10.579 7 11.6969 7H14.4991M14.4991 7H14.5002",
    stroke: "#2D53DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadicon);
export default __webpack_public_path__ + "static/media/uploadicon.3d248a30e8e5bebb2410c6265a96e4b7.svg";
export { ForwardRef as ReactComponent };